/* Cookie consent — Shopify Customer Privacy API.
   The banner markup ships hidden; it is revealed only when the API reports
   that the visitor's region requires consent and none is stored yet.
   Accept grants all tracking purposes, decline grants none — Shopify
   persists the choice and gates its own analytics/pixels accordingly. */
(function () {
  'use strict';

  var banner = document.getElementById('consentBanner');
  if (!banner || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      if (error) return;
      var cp = window.Shopify.customerPrivacy;
      if (!cp) return;

      var required = typeof cp.shouldShowBanner === 'function'
        ? cp.shouldShowBanner()
        : (typeof cp.shouldShowGDPRBanner === 'function' && cp.shouldShowGDPRBanner());
      if (!required) return;

      /* shouldShowBanner() only says the REGION needs a banner — it stays true
         after the visitor has answered, which re-opened the banner on every
         page after „Sutinku". Show it only while no choice is stored:
         getTrackingConsent() is 'no_interaction' until then, and
         currentVisitorConsent() holds '' for every purpose. */
      function answered() {
        if (typeof cp.getTrackingConsent === 'function') {
          var t = cp.getTrackingConsent();
          if (t && t !== 'no_interaction') return true;
        }
        if (typeof cp.currentVisitorConsent === 'function') {
          var c = cp.currentVisitorConsent() || {};
          return ['analytics', 'marketing', 'preferences', 'sale_of_data'].some(function (k) { return c[k] === 'yes' || c[k] === 'no'; });
        }
        return false;
      }
      if (answered()) return;

      /* Never stack on Shopify's own banner. The API reports that consent is
         required regardless of which banner is asking for it, so with the
         built-in one enabled in admin this would be the second dialog on the
         page. Shopify injects its banner asynchronously and can beat us or lose
         to us, so check now and keep watching briefly rather than trusting the
         order — that way turning the admin banner on or off needs no
         corresponding change here. */
      function shopifyOwnBanner() {
        return document.querySelector('#shopify-pc__banner, .shopify-pc__banner, .shopify-pc__banner__dialog');
      }
      if (shopifyOwnBanner()) return;

      var observer = new MutationObserver(function () {
        if (shopifyOwnBanner()) { banner.hidden = true; banner.classList.remove('is-open'); observer.disconnect(); }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 5000);

      banner.hidden = false;
      requestAnimationFrame(function () { banner.classList.add('is-open'); });

      function close() {
        banner.classList.remove('is-open');
        setTimeout(function () { banner.hidden = true; }, 300);
      }

      function respond(granted) {
        cp.setTrackingConsent(
          { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted },
          close
        );
      }

      banner.querySelector('[data-consent-accept]').addEventListener('click', function () { respond(true); });
      banner.querySelector('[data-consent-decline]').addEventListener('click', function () { respond(false); });
    }
  );
})();
